import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import lang from '@blade/common/pages/alert-details/lang/index';
import imagesBox from '@blade-sxp/alarm-center/pages/components/images-box.vue';
import textBox from '@blade-sxp/alarm-center/pages/components/text-box.vue';
import { resolveOfBigBatch } from '@blade/common/api/alarm-center';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import { AlarmDetailsModule } from '@blade/common/store/alarm-details';
import moment from 'moment';
import { AlarmCenterModule } from '@blade-sxp/alarm-center/store/index';
let default_1 = class default_1 extends Vue {
    list;
    listIdx;
    parentClassLength;
    permissionlevel = permissionlevel;
    lists = [];
    isTaskType = [
        'INCIDENT_PEDESTRIAN_ATTRIBUTE_UNMATCHED',
        'INCIDENT_FACE_UNMATCHED',
        'INCIDENT_AUTOMOBILE_LICENSE_PLATE_UNMATCHED',
        'INCIDENT_AUTOMOBILE_ATTRIBUTE_UNMATCHED',
    ]; // 人体未比中 人脸未比中 车牌未比中 车辆属性未比中
    dateStarts = null;
    dateEnds = null;
    getPortraitId(val) {
        let value = null;
        if (val?.incidentType === 'FACE_MATCH' ||
            val?.incidentType === 'FACE_PEDESTRIAN' ||
            val?.incidentType === 'INCIDENT_PEDESTRIAN_ATTRIBUTE_MATCHED') {
            value = val?.faceAnnotation?.portraitId || val?.pedestrianAnnotation?.portraitId || '';
        }
        return value;
    }
    getfoldBox(val) {
        return val.foldsTotal > 0 ? 'fold-box' : '';
    }
    getFoldNum(val) {
        const num = val.foldsTotal < 100 ? val.foldsTotal : '99+';
        return num;
    }
    showIncidentStatus(val) {
        return val === 'SOLVED' || val === 'IGNORED';
    }
    getType(val) {
        return val === 'SOLVED' ? 'alert-solved' : 'alert-ignored';
    }
    getText(val) {
        return val === 'SOLVED' ? this.$t('solved') : this.$t('ignored');
    }
    getDate(startDate, endDate, targetDate) {
        const startDates = new Date(startDate);
        const endDates = new Date(endDate);
        const targetDates = new Date(moment(Number(targetDate)).format('YYYY-MM-DD HH:mm:ss'));
        if (targetDates.getFullYear() === startDates.getFullYear() &&
            targetDates.getMonth() === startDates.getMonth() &&
            targetDates.getDate() === startDates.getDate()) {
            // 时间段 当前告警与开始时间为同一天
            const currentEndTime = moment(startDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
            this.dateEnds = currentEndTime;
            this.dateStarts = startDate;
        }
        else if (targetDates.getFullYear() === endDates.getFullYear() &&
            targetDates.getMonth() === endDates.getMonth() &&
            targetDates.getDate() === endDates.getDate()) {
            // 时间段 当前告警与结束时间为同一天
            const currentStartTime = moment(endDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
            this.dateEnds = endDate;
            this.dateStarts = currentStartTime;
        }
        else {
            // 时间段 当前告警在开始结束之间
            this.dateEnds = moment(Number(targetDate)).format('YYYY-MM-DD 23:59:59');
            this.dateStarts = moment(Number(targetDate)).format('YYYY-MM-DD 00:00:00');
        }
    }
    judgmentTime(searchdata, val) {
        this.dateEnds = new Date(searchdata.dateEnd);
        this.dateStarts = new Date(searchdata.dateStart);
        if (this.dateEnds.getFullYear() === this.dateStarts.getFullYear() &&
            this.dateEnds.getMonth() === this.dateStarts.getMonth() &&
            this.dateEnds.getDate() === this.dateStarts.getDate()) {
            // 判断筛选时间为同一天 就传当前筛选时间段
            this.dateEnds = searchdata?.dateEnd;
            this.dateStarts = searchdata?.dateStart;
        }
        else {
            if (!searchdata.dateEnd) {
                // 没筛选时间。传当前告警一整天
                this.dateEnds = moment(Number(val.alertTime)).format('YYYY-MM-DD 23:59:59');
                this.dateStarts = moment(Number(val.alertTime)).format('YYYY-MM-DD 00:00:00');
            }
            else {
                // 筛选时间为时间段的时候
                this.getDate(searchdata.dateStart, searchdata.dateEnd, val.alertTime);
            }
        }
    }
    async handleDetails(val, idx) {
        const searchdata = AlarmCenterModule.searchdata;
        AlarmCenterModule.updateBtnCardId(val?.id);
        this.judgmentTime(searchdata, val);
        // const incidentTypes = searchdata.incidentTypes ? [...searchdata.incidentTypes] : [];
        // 对应的任务才传任务类型 其余不传
        const incidentTypes = this.isTaskType.includes(val.incidentType) ? [val.incidentType] : [];
        let obj = {
            ...searchdata,
            incidentTypes: incidentTypes,
            foldedKey: val.foldedKey,
            page: 1,
            dateEnd: this.dateEnds,
            dateStart: this.dateStarts,
            // dateEnd: moment(Number(val.alertTime)).format('YYYY-MM-DD 23:59:59'),
            // dateStart: moment(Number(val.alertTime)).format('YYYY-MM-DD 00:00:00'),
        };
        const listIdxObj = {
            type: '',
            idx1: this.listIdx,
            idx2: idx,
        };
        const indexParm = {
            parentClassLength: this.$props.parentClassLength,
            parentClassIndex: this.$props.listIdx,
            subclassIndex: idx,
            subclassLength: this.list.length || 0,
        };
        AlarmDetailsModule.updatInhibit(indexParm);
        AlarmDetailsModule.updateParamTaskIds(obj);
        AlarmDetailsModule.updateListIdxs(listIdxObj);
        const list = await AlarmDetailsModule.getAlarmListFun(obj);
        AlarmDetailsModule.updatAalarNOChange(list.list);
        this.initTimeData(list);
        AlarmCenterModule.updateCardDate(val);
        this.$emit('show-detail-dialog');
    }
    // 不合理的定制化处理，当空条件查询，人群聚集或分散的详情都包含了两种情况不然会有数据缺失
    getIncidentTypes(searchTypes, detailType) {
        const types = [];
        const crowedTypes = ['INCIDENT_SCATTER', 'INCIDENT_CONGREGATE']; // 人群聚集分散INCIDENT_CONGREGATE
        const isCrowed = crowedTypes.includes(detailType);
        // 当搜索类型为空，且详情类型为人群聚集或者分散的，则都包含人群聚集和分散数据，原因： 后端鹏仔处理不了，只返回了其中一种类型，前端定制化处理，应当避免
        if ((searchTypes ?? []).length === 0 && isCrowed) {
            types.push(...crowedTypes);
        }
        else {
            types.push(detailType);
        }
        return types;
    }
    initTimeData(data, first) {
        let timeaArr = [];
        const b = data.list.reduce((prev, cur) => {
            if (!prev[this.timeDateFormat(cur.alertTime)]) {
                prev[this.timeDateFormat(cur.alertTime)] = [];
            }
            prev[this.timeDateFormat(cur.alertTime)].push(cur);
            return prev;
        }, {});
        for (let i in b) {
            timeaArr.push({
                timeTitle: i,
                lists: b[i],
            });
        }
        this.lists = timeaArr;
        AlarmDetailsModule.updateAlarConList(timeaArr);
        AlarmDetailsModule.updateDetailsData(this.lists?.[0]?.lists?.[0] ?? null);
    }
    timeDateFormat(time) {
        return moment(Number(time)).format('MMM-DD');
    }
    handleIgnoreAll(val) {
        this.resolveOfBigBatch(val, 'NO_REPORT');
    }
    handleSolvedAll(val) {
        this.resolveOfBigBatch(val, 'VERIFIED');
    }
    resolveOfBigBatch(val, resolveStatus) {
        const vehicleIds = val.automobileAnnotation?.vehicleId;
        const taskIds = val.taskConsist.taskId;
        const deviceIds = val.deviceId;
        let newObj = {};
        if (val?.incidentType === 'FACE_MATCH' || val?.incidentType === 'INCIDENT_PEDESTRIAN_ATTRIBUTE_MATCHED') {
            newObj = {
                portraitId: this.getPortraitId(val) || null,
            };
        }
        else if (val?.incidentType === 'INCIDENT_AUTOMOBILE_LICENSE_PLATE_MATCHED' ||
            val?.incidentType === 'INCIDENT_AUTOMOBILE_LICENSE_PLATE_MATCHED') {
            newObj = {
                vehicleIds: [vehicleIds],
            };
        }
        else {
            newObj = {
                deviceIds: [deviceIds],
            };
        }
        const searchdata = AlarmCenterModule.searchdata;
        this.judgmentTime(searchdata, val);
        // 对应的任务才传任务类型 其余不传
        const incidentTypes = this.isTaskType.includes(val.incidentType) ? [val.incidentType] : [];
        const reqParam = {
            ...AlarmCenterModule.searchdata,
            batchOperateRecord: {
                resolveStatus: resolveStatus,
            },
            recordIds: this.$route.query.recordIds ? [this.$route.query.recordIds] : null,
            // dateEnd: moment(Number(val.alertTime)).format('YYYY-MM-DD 23:59:59'),
            // dateStart: moment(Number(val.alertTime)).format('YYYY-MM-DD 00:00:00'),
            taskIds: [taskIds],
            page: 1,
            foldedKey: val.foldedKey,
            ...newObj,
            dateEnd: this.dateEnds,
            dateStart: this.dateStarts,
            incidentTypes: incidentTypes,
            portraitId: this.$route.query.portraitId || this.getPortraitId(val) || null,
        };
        resolveOfBigBatch({ ...reqParam })
            .then((res) => {
            this.$message({
                customClass: 'sub-message',
                message: res,
                type: 'success',
            });
            this.$emit('update-list');
        })
            .catch((err) => {
            this.$message({
                customClass: 'sub-message',
                type: 'error',
                message: err,
            });
        });
    }
};
__decorate([
    Prop()
], default_1.prototype, "list", void 0);
__decorate([
    Prop()
], default_1.prototype, "listIdx", void 0);
__decorate([
    Prop()
], default_1.prototype, "parentClassLength", void 0);
default_1 = __decorate([
    Component({
        name: 'TableCard',
        components: {
            imagesBox,
            textBox,
            AuthNewitem,
        },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
